import { tss } from 'tss-react/mui';

import wordIcon from 'Images/file-icons/microsoft/Word_64x.svg';
import excelIcon from 'Images/file-icons/microsoft/Excel_64.svg';
import powerpointIcon from 'Images/file-icons/microsoft/PowerPoint_64.svg';
import visioIcon from 'Images/file-icons/microsoft/visio_48x1.svg';
import { Or2Image } from '@/components/image/Or2Image';

interface Props {
  application: string;
}

const useStyles = tss.create(() => {
  return {
    icon: {
      width: 24,
      height: 24,
      position: 'relative',
      display: 'flex',
    },
  };
});

const iconMap: Record<string, string | null | undefined> = {
  word: wordIcon,
  excel: excelIcon,
  powerpoint: powerpointIcon,
  visio: visioIcon,
};

export const OfficeOnlineIcon = ({ application }: Props) => {
  const { classes } = useStyles();
  const appName = application.toLowerCase();
  const src = iconMap[appName];

  return (
    <div className={classes.icon}>
      {src && (
        <Or2Image src={src} alt={`${application} Online Icon`} size={50} />
      )}
    </div>
  );
};
